
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/topbusinessquotes/privacy-policy",
      function () {
        return require("private-next-pages/topbusinessquotes/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/topbusinessquotes/privacy-policy"])
      });
    }
  